"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _useTheme = _interopRequireDefault(require("@material-ui/core/styles/useTheme"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));
var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));
var _ReactLink = _interopRequireDefault(require("@micado-digital/react-link/ReactLink"));
var _useLink = _interopRequireDefault(require("@micado-digital/react-link/hooks/useLink"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _de = _interopRequireDefault(require("../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../locals/it.json"));
var _Menu = _interopRequireDefault(require("./Menu.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Menu = _ref => {
  let {
    lang
  } = _ref;
  const css = (0, _Menu.default)();
  const [localsLoaded, setLocalsLoaded] = (0, _react.useState)(false);
  const [value, setValue] = (0, _react.useState)(0);
  const location = (0, _reactRouterDom.useLocation)();
  const navigate = (0, _useLink.default)();
  const {
    pathname
  } = location || {};
  const theme = (0, _useTheme.default)();
  const isMobile = (0, _useMediaQuery.default)(theme.breakpoints.down("sm"));
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  (0, _react.useEffect)(() => {
    if (!(0, _isEmpty.default)(l("reactShop"))) {
      setLocalsLoaded(true);
    }
  }, [l]);
  const menuGroup = (0, _react.useMemo)(() => {
    return [{
      identifier: "products",
      title: l("reactShop.myAccount.menu.labels.digitalProducts"),
      link: "/".concat(lang, "/shop/myaccount/products")
    }, {
      identifier: "orders",
      title: l("reactShop.myAccount.menu.labels.orders"),
      link: "/".concat(lang, "/shop/myaccount/orders")
    }, {
      identifier: "customer",
      title: l("reactShop.myAccount.menu.labels.customer"),
      link: "/".concat(lang, "/shop/myaccount/customer")
    }, {
      identifier: "addresses",
      title: l("reactShop.myAccount.menu.labels.addresses"),
      link: "/".concat(lang, "/shop/myaccount/addresses")
    }, {
      identifier: "logout",
      title: l("reactShop.myAccount.menu.labels.logout"),
      link: "/".concat(lang, "/shop/logout")
    }];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang, localsLoaded]);
  (0, _react.useEffect)(() => {
    const index = menuGroup === null || menuGroup === void 0 ? void 0 : menuGroup.findIndex(_ref2 => {
      let {
        link
      } = _ref2;
      return pathname === link;
    });
    setValue(index !== null && index !== void 0 ? index : 0);
  }, [pathname, menuGroup]);
  const handleChange = (event, newValue) => {
    var _menuGroup$newValue;
    const link = menuGroup === null || menuGroup === void 0 || (_menuGroup$newValue = menuGroup[newValue]) === null || _menuGroup$newValue === void 0 ? void 0 : _menuGroup$newValue.link;
    if (!link) return;
    navigate(link);
    setValue(newValue);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.menu, "mco-shop-myaccount-menu")
  }, isMobile ? /*#__PURE__*/_react.default.createElement(_Tabs.default, {
    classes: {
      root: (0, _clsx.default)(css.tabs, "mco-shop-myaccount-menu__tabs")
    },
    indicatorColor: "primary",
    scrollButtons: "auto",
    textColor: "primary",
    value: value,
    variant: "scrollable",
    onChange: handleChange
  }, menuGroup === null || menuGroup === void 0 ? void 0 : menuGroup.map((_ref3, index) => {
    let {
      identifier,
      link,
      title
    } = _ref3;
    return /*#__PURE__*/_react.default.createElement(_Tab.default, {
      classes: {
        root: (0, _clsx.default)(css.tab, "mco-shop-myaccount-menu__tab", {
          [css.tabActive]: pathname.indexOf(link) > -1 && link !== "/".concat(lang, "/shop/myaccount")
        })
      },
      "data-identifier": identifier,
      key: index,
      label: title
    });
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: css.title
  }, /*#__PURE__*/_react.default.createElement(_ReactLink.default, {
    to: "/".concat(lang, "/shop/myaccount")
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.myAccount.menu.title",
    l: l
  }))), /*#__PURE__*/_react.default.createElement("ul", {
    className: css.list
  }, menuGroup === null || menuGroup === void 0 ? void 0 : menuGroup.map((_ref4, index) => {
    let {
      identifier,
      link,
      title
    } = _ref4;
    const isActive = pathname.indexOf(link) > -1 && link !== "/".concat(lang, "/shop/myaccount");
    return /*#__PURE__*/_react.default.createElement("li", {
      className: (0, _clsx.default)(css.item, "mco-shop-myaccount-menu__link"),
      "data-identifier": identifier,
      key: index
    }, /*#__PURE__*/_react.default.createElement(_ReactLink.default, {
      className: (0, _clsx.default)(css.link, {
        [css.linkActive]: isActive,
        "mco-shop-myaccount-menu__link--active": isActive
      }),
      to: link
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      component: "span"
    }, title)));
  }))));
};
var _default = exports.default = Menu;